// src/pages/RefundPolicy.js
import React from "react";
import "./TermsAndPolicy.css";

const RefundPolicy = () => {
  return (
    <div className="terms-and-policy-container">
      <h1>Andeon Apps Refund Policy</h1>
      <p>Last Updated: May 25, 2026</p>

      <h2>1. Summary</h2>
      <p>
        All sales are final. We do not offer refunds on subscriptions or
        credit purchases, except as required by applicable law or as
        expressly described below.
      </p>

      <h2>2. Subscriptions</h2>
      <p>
        You may cancel your subscription at any time from your account
        settings. Cancellation stops future renewals; your access and
        any remaining credit allotment for the current billing period
        continue until the period ends, after which your subscription
        and credit balance terminate. We do not provide refunds or
        credits for partial billing periods, unused credits, or periods
        of non-use.
      </p>

      <h2>3. Credit Packs</h2>
      <p>
        One-time credit purchases are non-refundable once the credits
        are added to your account.
      </p>

      <h2>4. Failed Generations</h2>
      <p>
        If a video generation fails due to a verifiable error on our
        side or the side of our AI provider, the credits consumed for
        that generation will be returned to your account balance
        automatically. This automatic credit return is the sole and
        exclusive remedy for failed generations and is not a cash
        refund.
      </p>

      <h2>5. Termination by Us</h2>
      <p>
        If we terminate your account for cause (including violation of
        the Terms of Service), any unused credit balance and any
        prepaid subscription period are forfeited and no refund is
        owed. If we terminate your account for our own convenience
        without cause, we will refund the pro-rata unused portion of
        your current subscription period.
      </p>

      <h2>6. Statutory Rights</h2>
      <p>
        Nothing in this policy limits any non-waivable refund right you
        may have under applicable consumer protection law.
      </p>

      <h2>7. Billing Disputes and Chargebacks</h2>
      <p>
        If you believe you have been charged in error, please contact
        us at legal@andeonapps.com before initiating a chargeback with
        your card issuer. We will work in good faith to resolve any
        billing issue. Initiating a chargeback without first contacting
        us may result in suspension or termination of your account.
      </p>

      <h2>8. Changes to This Policy</h2>
      <p>
        We may update this Refund Policy from time to time by posting
        the updated policy on this page and updating the "Last Updated"
        date above. Changes apply prospectively.
      </p>

      <h2>9. Contact Us</h2>
      <p>
        If you have any questions about this Refund Policy, please
        contact us at legal@andeonapps.com.
      </p>
    </div>
  );
};

export default RefundPolicy;
